import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ProductStart } from '@bca-user-data/models/_enums';
import { environment } from '@environments/environment';
import moment from 'moment';

@Component({
  selector: 'bca-use-product',
  templateUrl: 'use-product.component.html',
  styleUrls: ['use-product.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UseProductComponent implements OnInit, OnChanges {
  @Input()
  selectedProductUsage: ProductStart;
  @Input()
  selectedProductUsageDate: Date;
  @Input()
  useProduct: {
    value: ProductStart;
    displayText: string;
  }[] = [
    {
      value: ProductStart.DIRECTLY,
      displayText: 'USER_DATA.INPUT.DIRECTLY'
    },
    {
      value: ProductStart.DATE,
      displayText: 'USER_DATA.INPUT.ON_DATE'
    }
  ];

  @Output()
  selected = new EventEmitter<ProductStart>();
  @Output()
  dateSelected = new EventEmitter<Date>();
  formattedDate: string;
  datePreviouslySet = false;

  ngOnInit(): void {
    this.formatDate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedProductUsage'] && changes['selectedProductUsage'].currentValue !== ProductStart.DATE) {
      this.datePreviouslySet = false;
    }
    if (changes['selectedProductUsageDate']) {
      this.formatDate();
      if (changes['selectedProductUsageDate'].currentValue) {
        this.datePreviouslySet = true;
        this._cdr.markForCheck();
      }
    }
  }

  onDateChange(event: CustomEvent): void {
    this.formattedDate = this.datePipe.transform(event.detail.date, 'dd-MM-YYYY');
    this.datePreviouslySet = true;
    this.dateSelected.emit(event.detail.date);
  }

  minimalUseDate = moment()
    .add(environment.userData.useProductMinDays, 'days')
    .toDate();

  // Cutoff date is subject to change; update here when it does.
  private readonly latestSelectableStartDate = moment().month(9).date(10).startOf('day');

  maximalUseDate = moment.min(
    moment().add(environment.userData.useProductMaxDays, 'days'),
    this.latestSelectableStartDate
  ).toDate();

  ProductStart = ProductStart;
  constructor(private datePipe: DatePipe, private _cdr: ChangeDetectorRef) {}


  formatDate() {
    this.formattedDate = this.selectedProductUsageDate
      ? this.datePipe.transform(this.selectedProductUsageDate, 'dd-MM-YYYY')
      : null;
  }
}
